/* ============================================================
   Diata nav fix
   Top-level menu items that have a submenu are rendered by the theme
   as "trigger" links: clicking the label opens the submenu instead of
   following the href. Weight Loss therefore went nowhere even though
   its href is "/". The +/- control still handles opening the submenu,
   so the label itself should navigate.
   Only applies to parent links that have a real href.
   ============================================================ */
(function () {
  function realHref(a) {
    var h = a.getAttribute('href');
    return h && h !== '#' && h.trim() !== '';
  }

  function enable(a) {
    if (a.dataset.dtNav) return;
    a.dataset.dtNav = '1';
    a.addEventListener('click', function (e) {
      // let modified clicks (new tab, etc.) behave normally
      // only act on genuine user clicks -- a synthetic or programmatic
      // click must never navigate the page
      if (!e.isTrusted) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (!realHref(a)) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = a.getAttribute('href');
    }, true); // capture, so it runs before the theme's toggle handler
  }

  function scan() {
    document.querySelectorAll(
      'a.navlink--toplevel, a.mobile-navlink--level-1'
    ).forEach(function (a) {
      if (realHref(a)) enable(a);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // the drawer builds its markup lazily on some themes
  document.addEventListener('click', function () { setTimeout(scan, 120); });
})();


/* ── external links open in a new tab ──────────────────────────────────
   Instagram, TikTok and Facebook should not navigate the visitor away
   from diatahealth.com. Applied by host rather than by class so it also
   covers any social link the theme editor adds later. dt-extlinks */
(function(){
  function mark(){
    var here = location.hostname.replace(/^www\./,'');
    document.querySelectorAll('a[href^="http"]').forEach(function(a){
      var h;
      try { h = new URL(a.href).hostname.replace(/^www\./,''); } catch(e){ return; }
      if (h === here) return;                       // same site, stay put
      if (a.hasAttribute('download')) return;
      if (a.dataset.dtExt) return;            // mark() runs twice; do it once
      a.dataset.dtExt = '1';
      a.target = '_blank';
      var rel = (a.rel || '').split(/\s+/).filter(Boolean);
      ['noopener','noreferrer'].forEach(function(t){
        if (rel.indexOf(t) === -1) rel.push(t);
      });
      a.rel = rel.join(' ');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mark);
  } else { mark(); }
  // the footer/newsletter can re-render after load
  setTimeout(mark, 1200);
})();
